define(['jquery', 'jquery.transit', 'modernizr', 'container'], function ($, transit, modernizr, container) {

    var jump = function (id) {

        var publicVars = {
        };

        var privateVars = {
            name: 'jump(' + id + ')',
        };


        var privateMethods = {
            prepareObj: function (options) {
                publicVars = $.extend(true, publicVars, options);

                privateMethods.startup();
                privateMethods.bind();
            },
            startup: function () {

            },
            bind: function () {
                container.msg(privateVars.name + ' - module started');
            },
            jumpTo: function (handler, options, callback) {
                var state = 0;
                var options = options || {};

                var topPos = $(handler).offset();

                var modifier = parseInt(options.modifier) || 0;
                var easing = options.easing || 'linear';
                var speed = options.speed !== undefined ? options.speed : 800;

                $('html, body').animate({scrollTop: (topPos.top + modifier) + 'px'}, speed, easing,function () {

                    if (state == 0)
                    {
                        state = 1;

                        if (typeof callback === 'function') {
                            callback();
                        }
                    }

                });
            },
            centerTo: function (handler, callback, options) {
                var options = options || {};
                var offsetTop = $(handler).offset().top;
                var speed = options.speed !== undefined ? options.speed : 200;
                var modifier = parseInt(options.modifier) || 0;

                var windowHeight = $(window).height();

                if(modifier !== 0) {
                    windowHeight = windowHeight + modifier;
                }

                if(options.stripAdjust && options.stripAdjust === true) {
                    var adjustment = (windowHeight - $(handler).outerHeight()) / 2;
                } else {
                    var adjustment = Math.max(0, (windowHeight - $(handler).outerHeight()) / 2);
                }

                if(modifier && !adjustment) {
                    adjustment = - modifier;
                } else if(modifier) {
                    adjustment = adjustment - (modifier);
                }

                var scrollTop = offsetTop - adjustment;

                if(speed == 0) {
                    $('html,body').scrollTop(scrollTop);

                    if (typeof callback === 'function') {
                        callback();
                    }
                } else {
                    var state = 0;

                    $('html,body').animate({
                        scrollTop: scrollTop
                    }, speed, function () {
                        if (state == 0) {
                            state = 1;

                            if (typeof callback === 'function') {
                                callback();
                            }
                        }
                    });
                }

            }
        };


        var publicObj = {
            init: function (options) {
                privateMethods.prepareObj(options);
            },
            jumpTo: function (handler, modifier, callback) {
                privateMethods.jumpTo(handler, modifier, callback);
            },
            centerTo: function (handler, callback, options) {
                privateMethods.centerTo(handler, callback, options);
            }

        }

        return publicObj;
    };

    var factory = {
        objId: 0,
        /**
         * Get new preloader object
         *
         * @returns preloader
         */
        create: function () {
            factory.objId++;

            var obj = jump(factory.objId);

            return obj;
        }
    };

    return {
        create: factory.create
    }

});

/*
 ---
 var jump = jumpFactory.create();
 ---
 jump.jumpTo(view.publicVars.cssId.homeQuestionTop, function() {});
 ---
 jump.centerTo(view.publicVars.cssId.homeQuestionTop, function() {});
 ---
 */